import { NgModule, APP_INITIALIZER } from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {RouterModule } from '@angular/router';
import { environment } from 'environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MaterialModule } from './module/obs.core/material.module';
import {ServiceWorkerService} from './services/navigation/service-worker.service';
import {CommonModule} from '@angular/common';
import {StartupService} from './services/startup.service';
import {LoadingScreenInterceptor} from './services/interceptors/ladeanzeige.interceptor';
import {CoreModule} from './module/obs.core/core.module';

import wbpRoutes from './module/obs.core/routes/web.routes'
import wbaRoutes from './module/obs.core/routes/app.routes'
import {WbpComponent} from './module/obs.core/components/wbp/wbp.component';
import {WbaComponent} from './module/obs.core/components/wba/wba.component';
import {ErrorInterceptor} from './services/interceptors/error.interceptor';
import {HTTPInterceptorService} from './services/interceptors/response.interceptor';

export function initApp(startupService: StartupService) {
  return async () => {
    await startupService.initMandant()
    await startupService.initKunde()
    startupService.initBarriereFreihheit()
    startupService.routen()
  }
}

@NgModule({
  declarations: [],
  imports: [
    CoreModule,
    CommonModule,
    RouterModule,
    MaterialModule,
    RouterModule.forRoot(environment.type == 'web' ? wbpRoutes : wbaRoutes, {useHash: true}),
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
      scope: environment.type == 'web' ? '/' : '/mobil/'
    }),
  ],
  providers: [
    ServiceWorkerService,
    { provide: APP_INITIALIZER, useFactory: initApp, deps: [StartupService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingScreenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HTTPInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [environment.type == 'web' ? WbpComponent: WbaComponent]
})
export class AppModule {}
